export const environment = {
  production: false,
  API_SERVER: 'https://mailapi.iservices.com.ng/dev/api/v1/',
  // API_SERVER: 'https://7vo02i2k39.execute-api.us-east-2.amazonaws.com/api/v1/',
};
